module.exports = __webpack_public_path__ + "img/ikone-fundo-branco.13db1e84.svg";